import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import styles from "./styles.css";
import * as helpers from "./data-helpers";
import { Button } from "../../../../common/components";
import LocationBlock from "../../components/LocationBlock";
import toolkit from "../../../../common/utils/toolkit";

class FullHeader extends React.Component {
  _scrollToRegister = () => {
    setTimeout(() => {
      window.scrollTo(
        0,
        ReactDOM.findDOMNode(this.refs.headerBottom).offsetTop
      );
    }, 2);
  };

  render() {
    console.log(this.props.event.longDescription);
    const { event = {} } = this.props;
    const prices = (event.pricing || []).map(price => ({
      ...price,
      IsEarly: (price.publishDateType || "").toLocaleLowerCase() === "early"
    }));

    const earlyPrice = prices.find(p => p.IsEarly);
    const hasEarlyPrices = Boolean(earlyPrice);
    const earlyEndDate = hasEarlyPrices ? earlyPrice.endDate : "";
    const inEarlyPeriod =
      hasEarlyPrices && moment().isBefore(moment(earlyEndDate));

    const tablePrices = prices
      .filter(p => {
        if (hasEarlyPrices) {
          return p.isTable && inEarlyPeriod === p.IsEarly;
        }
        return p.isTable;
      })
      .sort((a, b) =>
        (a.tableName + a.name).localeCompare(b.tableName + b.name)
      );

    const individualPrices = prices
      .filter(p => {
        if (hasEarlyPrices) {
          return !p.isTable && inEarlyPeriod === p.IsEarly;
        }
        return !p.isTable;
      })
      .sort((a, b) =>
        (a.tableName + a.name).localeCompare(b.tableName + b.name)
      );

    var eventFull = "true";
    toolkit.log(
      `Registered users are ${event.numberRegistered} of ${event.capacity}`
    );
    try {
      let numberRegistered = parseInt(event.numberRegistered, 10);
      let capacity = parseInt(event.capacity, 10);

      if (numberRegistered >= capacity || capacity < 1) {
        eventFull = "true";
      } else {
        eventFull = "false";
      }
      sessionStorage.setItem("engage-eventfull", eventFull);
    } catch (Exception) {
      console.log(Exception.message);
    }
    return (
      <div>
        <div className={styles.header}>
          <div
            className={styles.image}
            style={{ backgroundImage: `url('${event.imageUrl}')` }}
          />
          <div className={styles.details}>
            <h6 className={styles.title}>{event.title}</h6>
            <p className={styles["dates"]}>
              {helpers.buildDetailDateStr(event)}
            </p>
            {!event.isRemote && (
              <div>
                <strong className={styles["sub-header"]}>Location</strong>
                <p className={styles["long-description"]}>
                  <LocationBlock {...event} />
                </p>
              </div>
            )}
            <div className={styles["short-description"]}>
              {event.shortDescription}
            </div>
          </div>
        </div>
        <div id="pricing" className={styles["cta-section"]}>
          <div className={styles["cta-left"]}>
            <strong>{helpers.getVenue(event)}</strong>
            <span className={styles["price-summary"]}>
              {helpers.getPriceMinMax(event)}
            </span>
          </div>
          {(eventFull === null || eventFull !== "true" || eventFull === "") && (
            <div className={styles["cta-right"]}>
              <Button
                label={"Register for Event"}
                to={`/events/${event.key}/register`}
                onClick={() => this._scrollToRegister()}
              />
            </div>
          )}
          {eventFull != null && eventFull === "true" && (
            <p className={styles["cta-right"]}>
              <p id="thanksMessageReplaceButton">
                Thank you for your interest in this NFIB event.
                <br />
                Currently, no seats are available. If you have questions, please
                contact NFIB by calling the number provided in the event
                description or
                <br />
                1-800-NFIB-NOW.
              </p>
            </p>
          )}
        </div>
        <div className={styles["details-section"]}>
          <div className={styles["details-left"]}>
            <strong className={styles["sub-header"]}>Description</strong>
            <p
              className={styles["long-description"]}
              dangerouslySetInnerHTML={{ __html: event.longDescription }}
            />
          </div>
          <div className={styles["details-right"]}>
            {!event.isFree && (
              <div className={styles["price-lists"]}>
                <strong className={styles["sub-header"]}>Event Pricing</strong>
                {Boolean(individualPrices.length) && (
                  <ul className={styles["price-list"]}>
                    <div className={styles["price-list-header"]}>
                      Individual
                    </div>
                    {individualPrices.map(p => (
                      <li key={`p${p.key}`}>
                        <span className={styles["price-name"]}>{p.name}</span>$
                        {p.price}
                      </li>
                    ))}
                  </ul>
                )}
                {Boolean(tablePrices.length) && (
                  <ul className={styles["price-list"]}>
                    <div className={styles["price-list-header"]}>Table</div>
                    {tablePrices.map(p => (
                      <li key={`p${p.key}`}>
                        <span className={styles["price-name"]}>
                          {p.tableName} - {p.name}
                        </span>
                        ${p.price}
                      </li>
                    ))}
                  </ul>
                )}
                {hasEarlyPrices && (
                  <p>
                    <br />
                    <em>
                      Early pricing ends{" "}
                      {moment(earlyEndDate).format("MM/DD/YYYY")}
                    </em>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
        <div ref="headerBottom" />
      </div>
    );
  }
}

export default FullHeader;



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/FullHeader.js